import { stores } from '@stores'
import { action, computed, observable } from 'mobx'
import uniq from 'lodash/uniq'
import { SORT_ORDERS } from '@components/UI-Components/EnhancedView/Sort/sort_constants'
import { getChannelName } from '@utils/get-channel-name'
import { isEmpty } from 'lodash'

export interface EnhancedSortOptions {
  name: string
  value: string
  isSelected: boolean
  sortOrder: string
  quantityType: string
}

export class EnhancedSortStore {
  @observable selectedSortOption = null
  @observable sortAttributeList = []
  @observable sortSearchText = ''

  @computed get showSortSearchInput() {
    return this.sortAttributeList.length > 10
  }

  @computed get isSortApplied() {
    return !!this.selectedSortOption?.id
  }

  @computed get filteredSortAttributesList() {
    const txt = this.sortSearchText?.toLowerCase().trim() || ''
    let temp = this.sortAttributeList
    if (txt) {
      temp = this.sortAttributeList.filter(item =>
        item?.displayName?.toLowerCase().includes(txt)
      )
    }
    return temp
  }

  @action
  handleSortChange = (id, orderBy = SORT_ORDERS.ASC) => {
    this.selectedSortOption = { id, orderBy }
  }

  @action
  updateSortSearchText = value => {
    this.sortSearchText = value
  }

  @action
  setSortAttributesList = viewName => {
    const {
      nav: {
        queryParams: { clientType }
      },
      productConfiguration: {
        getActionAttributes,
        findSpecificAttribute,
        defaultValuesFromConfig
      }
    } = stores
    const sortAttributes = getActionAttributes(
      'sortBy',
      getChannelName(clientType),
      viewName
    )
    const sortSymbol = (defaultValuesFromConfig?.sortBy || '').charAt(0)
    const defaultSortAttr = ['+', '-'].includes(sortSymbol)
      ? defaultValuesFromConfig?.sortBy.slice(1)
      : defaultValuesFromConfig?.sortBy
    let tempAttrObj: any = null
    if (defaultSortAttr) {
      tempAttrObj = findSpecificAttribute(defaultSortAttr)
    }
    const allAttributes = tempAttrObj
      ? [tempAttrObj].concat(sortAttributes)
      : sortAttributes
    this.sortAttributeList = uniq(allAttributes)
    if (defaultSortAttr && isEmpty(this.selectedSortOption)) {
      this.selectedSortOption = {
        id: defaultSortAttr,
        orderBy: sortSymbol === '-' ? SORT_ORDERS.DESC : SORT_ORDERS.ASC
      }
    }
  }

  @action
  resetEnhancedSortData = () => {
    this.selectedSortOption = null
    this.sortAttributeList = []
    this.sortSearchText = ''
  }
}
